module.exports = __webpack_public_path__ + "static/main-logo-650e738bd90e51f8506c845a9e7d7760.png";